unit CostingEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.Grids,
  Vcl.Grids,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Types,
  Rtti,
  MainDataModule,
  Grid.Plugins,
  WEBLib.Lists,
  smx.webcore.types;

type
  TCostingEditForm = class(TBaseEditForm)
    RecordId: TDBLabel;
    TitleEdit: TDBEdit;
    ValidFromEdit: TDBDateTimePicker;
    ValidToEdit: TDBDateTimePicker;
    ChildDataSource: TDataSource;
    DetailTable: TDBTableControl;
    AddDetailButton: TButton;
    procedure DetailTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure AddDetailButtonClick(Sender: TObject);
    procedure SaveButtonClick(Sender: TObject);
    procedure DetailTableGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
  private
    { Private declarations }
    FItemUpdated: Boolean;
    FCostingId: Integer;

    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    procedure DeleteRecord(const ARecordId: string);
    function GetFieldNameByColIndex(ACol: Integer): string;

    procedure OnCellBlurEvent(Event: TJSEvent);
    procedure OnCellInputEvent(Event: TJSEvent);

  protected
    function GetRequiredEditLevel: string; override;

    procedure AfterSetDataset; override;

    function CanSaveThis: Boolean; override;

  public
    { Public declarations }
    [async]
    procedure InitForm; async; override;

  protected procedure LoadDFMValues; override; end;

var
  CostingEditForm: TCostingEditForm;

implementation

{$R *.dfm}

uses
  App.Enumerations,
  App.Shared,
  smx.web.Layout.Utils,
  AcademyEditPage;

procedure TCostingEditForm.DetailTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
begin
  inherited;

  if DetailTable.Columns[ACol].Title = 'Actions' then
    AddRowActions(MainData.CostingDetailDataSet.FieldByName(FIdField).AsString, AElement.Element)
  else if ACol = 0 then
    AElement.element.style.setProperty('display', 'none')
  else if (ARow > 0) and (ACol >= 0) and (ACol < DetailTable.Columns.Count - 1) then
  begin
    // Make cells editable
    AElement.element.setAttribute('contenteditable', 'true');
    AElement.element.setAttribute('class', AElement.element.getAttribute('class') + ' editable-cell');

    // Store the data in the cell for use later
    AElement.element.setAttribute('data-col-index', IntToStr(ACol));
    AElement.element.setAttribute('data-field-name', GetFieldNameByColIndex(ACol));
    AElement.element.setAttribute('data-record-id', MainData.CostingDetailDataSet.FieldByName(FIdField).AsString);

    // Add events to handle input sanitization
    AElement.element.addEventListener('blur', @OnCellBlurEvent);
    AElement.element.addEventListener('input', @OnCellInputEvent);

  end;

end;

procedure TCostingEditForm.DetailTableGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  inherited;

  if Assigned(AField) then
    if AField.FieldName = 'CostValue' then
      AValue := Format('£%.2n', [StrToFloatDef(AValue,0)]);

end;

procedure TCostingEditForm.OnCellBlurEvent(Event: TJSEvent);
var
  Element: TJSHTMLElement;
  RecordId, NewValue: string;
  ColIndex: Integer;
  FieldName: string;
begin
  Element := TJSHTMLElement(Event.target);
  RecordId := Element.getAttribute('data-record-id');
  ColIndex := StrToIntDef(Element.getAttribute('data-col-index'), -1);

  if (RecordId <> '') and (ColIndex >= 0) then
  begin
    NewValue := StringReplace(Element.innerText, '£', '', [rfReplaceAll]);
    FieldName := GetFieldNameByColIndex(ColIndex);

    if (FieldName <> '') and MainData.CostingDetailDataSet.Locate('Id', RecordId, []) then
    begin
      MainData.CostingDetailDataSet.Edit;

      // Handle different field types appropriately
      if MainData.CostingDetailDataSet.FieldByName(FieldName) is TIntegerField then
        MainData.CostingDetailDataSet.FieldByName(FieldName).AsInteger := StrToIntDef(NewValue, 0)
      else if MainData.CostingDetailDataSet.FieldByName(FieldName) is TNumericField then
        MainData.CostingDetailDataSet.FieldByName(FieldName).AsFloat := StrToFloatDef(NewValue, 0)
      else
        MainData.CostingDetailDataSet.FieldByName(FieldName).AsString := NewValue;

      MainData.CostingDetailDataSet.Post;
      MainData.CostingDetailDataSet.ApplyUpdates;

      FItemUpdated := True;

    end;

  end;

end;

function TCostingEditForm.GetFieldNameByColIndex(ACol: Integer): string;
begin
  // Map column index to field name
  if ACol < DetailTable.Columns.Count then
    Result := DetailTable.Columns[ACol].DataField
  else
    Result := '';

end;

procedure TCostingEditForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
var
  DeleteSpan: THTMLSpan;

  procedure DeleteItemClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);

  end;

begin
  inherited;

  DeleteSpan := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash fa-fw fa-lg', 'Delete');
  DeleteSpan.OnClick := @DeleteItemClick;

end;

function TCostingEditForm.GetRequiredEditLevel: string;
begin
  Result :=
    USER_SCOPES[TUserScope.Administrator] + ',' +
    USER_SCOPES[TUserScope.Customer];

end;

procedure TCostingEditForm.SaveButtonClick(Sender: TObject);
begin
  inherited;

  if FItemUpdated then
    MainData.CostingDetailDataSet.ApplyUpdates;

end;

procedure TCostingEditForm.DeleteRecord(const ARecordId: string);
begin
  if MainData.CostingDetailDataSet.Locate('Id', ARecordId, []) then
  begin
    MainData.CostingDetailDataSet.Delete;

    FItemUpdated := True;

  end;

end;

procedure TCostingEditForm.AddDetailButtonClick(Sender: TObject);
begin
  inherited;

  // Add the new record
  MainData.CostingDetailDataSet.DisableControls;
  MainData.CostingDetailDataSet.Append;
  MainData.CostingDetailDataSet.FieldByName('CostingId').AsInteger := FCostingId;
  MainData.CostingDetailDataSet.Post;

  MainData.CostingDetailDataSet.EnableControls;

  FItemUpdated := True;

end;

procedure TCostingEditForm.AfterSetDataset;
begin
  inherited;

  FCostingId := DataSource.DataSet.FieldByName('Id').AsInteger;
  AddDetailButton.Visible := FCostingId <> 0;

end;

function TCostingEditForm.CanSaveThis: Boolean;
begin
  Result := inherited;

  Result := Result or MainData.CostingDetailDataSet.Modified or FItemUpdated;

  if Result then
    DataSource.DataSet.Edit;

end;


procedure TCostingEditForm.OnCellInputEvent(Event: TJSEvent);
var
	oElement: TJSHTMLElement;
	sSource, sTarget: string;
	iIdx: Integer;
	bDotSeen, bMinusSeen: Boolean;
	cCurrent: Char;

begin
	oElement := TJSHTMLElement(Event.target);
	sSource := oElement.innerText;

	sTarget := '';
	bDotSeen := False;
	bMinusSeen := False;

	for iIdx := 1 to Length(sSource) do
	begin
		cCurrent := sSource[iIdx];

		if (cCurrent in ['0'..'9']) then
			sTarget := sTarget + cCurrent
		else if (cCurrent in ['.', ',']) and not bDotSeen then
		begin
			sTarget := sTarget + cCurrent;
			bDotSeen := True;

		end
		else if (cCurrent = '-') and (sTarget = '') and not bMinusSeen then
		begin
			sTarget := '-';
			bMinusSeen := True;

		end;

	end;

	if sTarget <> sSource then
		oElement.innerText := sTarget;

end;


procedure TCostingEditForm.InitForm;
begin
  inherited;

  ChildDataSource.DataSet := MainData.CostingDetailDataSet;

end;



procedure TCostingEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  RecordId := TDBLabel.Create('record-id');
  TitleEdit := TDBEdit.Create('title-edit');
  ValidFromEdit := TDBDateTimePicker.Create('valid-from');
  ValidToEdit := TDBDateTimePicker.Create('valid-to');
  DetailTable := TDBTableControl.Create('ChildDataTable');
  AddDetailButton := TButton.Create('add-item');
  ChildDataSource := TDataSource.Create(Self);

  RecordId.BeforeLoadDFMValues;
  TitleEdit.BeforeLoadDFMValues;
  ValidFromEdit.BeforeLoadDFMValues;
  ValidToEdit.BeforeLoadDFMValues;
  DetailTable.BeforeLoadDFMValues;
  AddDetailButton.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  EditElements.BeforeLoadDFMValues;
  ChildDataSource.BeforeLoadDFMValues;
  try
    Caption := 'ChildDataSource';
    RecordId.SetParentComponent(Self);
    RecordId.Name := 'RecordId';
    RecordId.Left := 40;
    RecordId.Top := 72;
    RecordId.Width := 47;
    RecordId.Height := 15;
    RecordId.Caption := 'RecordId';
    RecordId.ElementFont := efCSS;
    RecordId.ElementPosition := epIgnore;
    RecordId.HeightStyle := ssAuto;
    RecordId.HeightPercent := 100.000000000000000000;
    RecordId.Visible := False;
    RecordId.WidthStyle := ssAuto;
    RecordId.WidthPercent := 100.000000000000000000;
    RecordId.DataField := 'Id';
    TitleEdit.SetParentComponent(Self);
    TitleEdit.Name := 'TitleEdit';
    TitleEdit.Left := 40;
    TitleEdit.Top := 128;
    TitleEdit.Width := 121;
    TitleEdit.Height := 22;
    TitleEdit.ChildOrder := 10;
    TitleEdit.ElementClassName := 'form-control';
    TitleEdit.ElementFont := efCSS;
    TitleEdit.ElementPosition := epIgnore;
    TitleEdit.HeightStyle := ssAuto;
    TitleEdit.HeightPercent := 100.000000000000000000;
    TitleEdit.MaxLength := 50;
    TitleEdit.TabOrder := 1;
    TitleEdit.Text := 'TitleEdit';
    TitleEdit.WidthStyle := ssAuto;
    TitleEdit.WidthPercent := 100.000000000000000000;
    TitleEdit.DataField := 'Title';
    TitleEdit.DataSource := DataSource;
    ValidFromEdit.SetParentComponent(Self);
    ValidFromEdit.Name := 'ValidFromEdit';
    ValidFromEdit.Left := 40;
    ValidFromEdit.Top := 156;
    ValidFromEdit.Width := 170;
    ValidFromEdit.Height := 22;
    ValidFromEdit.ElementClassName := 'form-control';
    ValidFromEdit.HeightStyle := ssAuto;
    ValidFromEdit.WidthStyle := ssAuto;
    ValidFromEdit.BorderStyle := bsSingle;
    ValidFromEdit.ChildOrder := 11;
    ValidFromEdit.Color := clWhite;
    ValidFromEdit.Date := 45730.479826215280000000;
    ValidFromEdit.ElementFont := efCSS;
    ValidFromEdit.ElementPosition := epIgnore;
    ValidFromEdit.Role := '';
    ValidFromEdit.TabOrder := 2;
    ValidFromEdit.Text := '';
    ValidFromEdit.DataField := 'ValidFrom';
    ValidFromEdit.DataSource := DataSource;
    ValidToEdit.SetParentComponent(Self);
    ValidToEdit.Name := 'ValidToEdit';
    ValidToEdit.Left := 40;
    ValidToEdit.Top := 184;
    ValidToEdit.Width := 170;
    ValidToEdit.Height := 22;
    ValidToEdit.ElementClassName := 'form-control';
    ValidToEdit.HeightStyle := ssAuto;
    ValidToEdit.WidthStyle := ssAuto;
    ValidToEdit.BorderStyle := bsSingle;
    ValidToEdit.ChildOrder := 12;
    ValidToEdit.Color := clWhite;
    ValidToEdit.Date := 45730.479838379630000000;
    ValidToEdit.ElementFont := efCSS;
    ValidToEdit.ElementPosition := epIgnore;
    ValidToEdit.Role := '';
    ValidToEdit.TabOrder := 3;
    ValidToEdit.Text := '';
    ValidToEdit.DataField := 'ValidTo';
    ValidToEdit.DataSource := DataSource;
    DetailTable.SetParentComponent(Self);
    DetailTable.Name := 'DetailTable';
    DetailTable.Left := 228;
    DetailTable.Top := 156;
    DetailTable.Width := 421;
    DetailTable.Height := 181;
    DetailTable.HeightStyle := ssAuto;
    DetailTable.WidthStyle := ssPercent;
    DetailTable.BorderColor := clSilver;
    DetailTable.ChildOrder := 21;
    DetailTable.ElementFont := efCSS;
    DetailTable.ElementHeaderClassName := 'thead-light';
    DetailTable.ElementPosition := epIgnore;
    DetailTable.ElementTableClassName := 'table table-striped table-bordered table-hover';
    DetailTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    DetailTable.Footer.ButtonElementClassName := 'btn btn-light';
    DetailTable.Footer.DropDownElementClassName := 'form-control';
    DetailTable.Footer.InputElementClassName := 'form-control';
    DetailTable.Footer.LinkActiveElementClassName := 'link-primary';
    DetailTable.Footer.LinkElementClassName := 'link-secondary';
    DetailTable.Footer.ListElementClassName := 'pagination';
    DetailTable.Footer.ListItemElementClassName := 'page-item';
    DetailTable.Footer.ListLinkElementClassName := 'page-link';
    DetailTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    DetailTable.Header.ButtonElementClassName := 'btn btn-light';
    DetailTable.Header.DropDownElementClassName := 'form-control';
    DetailTable.Header.InputElementClassName := 'form-control';
    DetailTable.Header.LinkActiveElementClassName := 'link-primary';
    DetailTable.Header.LinkElementClassName := 'link-secondary';
    DetailTable.Header.ListElementClassName := 'pagination';
    DetailTable.Header.ListItemElementClassName := 'page-item';
    DetailTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(DetailTable, Self, 'OnGetCellData', 'DetailTableGetCellData');
    SetEvent(DetailTable, Self, 'OnGetCellChildren', 'DetailTableGetCellChildren');
    DetailTable.Columns.Clear;
    with DetailTable.Columns.Add do
    begin
      DataField := 'Id';
      Width := 100;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'PupilMin';
      Title := 'Min Pupils';
      Width := 100;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'PupilMax';
      Title := 'Max Pupils';
      Width := 100;
    end;
    with DetailTable.Columns.Add do
    begin
      DataField := 'CostValue';
      Title := 'Cost Value';
      Width := 120;
    end;
    with DetailTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 100;
    end;
    DetailTable.DataSource := ChildDataSource;
    AddDetailButton.SetParentComponent(Self);
    AddDetailButton.Name := 'AddDetailButton';
    AddDetailButton.Left := 613;
    AddDetailButton.Top := 343;
    AddDetailButton.Width := 36;
    AddDetailButton.Height := 38;
    AddDetailButton.Caption := 'Add';
    AddDetailButton.ChildOrder := 22;
    AddDetailButton.ElementClassName := 'btn btn-primary';
    AddDetailButton.ElementFont := efCSS;
    AddDetailButton.ElementPosition := epIgnore;
    AddDetailButton.HeightStyle := ssAuto;
    AddDetailButton.HeightPercent := 100.000000000000000000;
    AddDetailButton.WidthStyle := ssAuto;
    AddDetailButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddDetailButton, Self, 'OnClick', 'AddDetailButtonClick');
    DataSource.Top := 16;
    EditElements.Left := 408;
    EditElements.Top := 16;
    ChildDataSource.SetParentComponent(Self);
    ChildDataSource.Name := 'ChildDataSource';
    ChildDataSource.Left := 528;
    ChildDataSource.Top := 16;
  finally
    RecordId.AfterLoadDFMValues;
    TitleEdit.AfterLoadDFMValues;
    ValidFromEdit.AfterLoadDFMValues;
    ValidToEdit.AfterLoadDFMValues;
    DetailTable.AfterLoadDFMValues;
    AddDetailButton.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    EditElements.AfterLoadDFMValues;
    ChildDataSource.AfterLoadDFMValues;
  end;
end;

end.


